import { useStateWithBrowserStorage } from '@farmersdog/utils';
import noop from 'lodash/noop';
import { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'src/reducers/signup/user';

const AUTO_RENEWAL_ACCEPTANCE_KEY = 'cvr_has_accepted_auto_renewal';

type AutoRenewalAcceptanceContextValue = [
  hasAcceptedAutorenewal: boolean,
  setHasAcceptedAutorenewal: (
    value: boolean | ((oldState: boolean) => boolean)
  ) => void,
];

const AutoRenewalAcceptanceContext =
  createContext<AutoRenewalAcceptanceContextValue>([false, noop]);

export function AutoRenewalAcceptanceProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const userId = useSelector(selectUser).id;
  const storageKey = getStorageKey(userId);

  const [autoRenewalAcceptance, setAutoRenewalAcceptance] =
    useStateWithBrowserStorage<boolean>(false, storageKey, 'localStorage');

  return (
    <AutoRenewalAcceptanceContext.Provider
      value={[autoRenewalAcceptance, setAutoRenewalAcceptance]}
    >
      {children}
    </AutoRenewalAcceptanceContext.Provider>
  );
}

export function useAutoRenewalAcceptance() {
  return useContext(AutoRenewalAcceptanceContext);
}

function getStorageKey(userId: number) {
  return `${AUTO_RENEWAL_ACCEPTANCE_KEY}-user_id_${userId}`;
}
